import { render, staticRenderFns } from "./EditTaxonomyKingdom.vue?vue&type=template&id=4b448024&"
import script from "./EditTaxonomyKingdom.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyKingdom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports